// hooks/support/auditLogs/useAuditLogs.ts
import { useState, useCallback } from "react";
import { AuditLogEntry } from "../../../types/features/support/AuditLog";
import { auditLogService } from "../../../services/support/auditLogService";

export default function useAuditLogs() {
  const [logs, setLogs] = useState<AuditLogEntry[]>([]);
  const [searchedEmail, setSearchedEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    total: 0,
    perPage: 50,
  });

  const searchByEmail = useCallback(
    async (
      email: string,
      page: number = 1,
      filters?: { method?: string; from_date?: string; to_date?: string }
    ) => {
      setLoading(true);
      setError(null);
      try {
        const response = await auditLogService.searchByEmail(email, page, 50, filters);
        setLogs(response.logs);
        setSearchedEmail(response.email);
        setPagination({
          currentPage: response.page,
          total: response.total,
          perPage: response.size,
        });
      } catch (err) {
        setError("Erreur lors de la recherche des logs d'audit");
        setLogs([]);
        console.error(err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const clearResults = useCallback(() => {
    setLogs([]);
    setSearchedEmail("");
    setPagination({ currentPage: 1, total: 0, perPage: 50 });
  }, []);

  return {
    logs,
    searchedEmail,
    loading,
    error,
    pagination,
    searchByEmail,
    clearResults,
  };
}
